export default {
  assign_petition: 'assign petition',
  create_scan_issue: 'create scan issue',
  read_scan_issue: 'read scan issue',
  assign_petition_for_qa: 'assign petition for qa',
  create_initiative: 'create initiative',
  create_jurisdiction: 'create jurisdiction',
  create_landing_page: 'create landing page',
  create_organization: 'create organization',
  create_petition: 'create petition',
  create_push: 'create push',
  create_setting: 'create setting',
  create_team: 'create team',
  create_user: 'create user',
  created_at: 'created_at',
  delete_initiative: 'delete initiative',
  delete_jurisdiction: 'delete jurisdiction',
  delete_landing_page: 'delete landing page',
  delete_organization: 'delete organization',
  delete_petition: 'delete petition',
  delete_push: 'delete push',
  delete_setting: 'delete setting',
  delete_team: 'delete team',
  delete_user: 'delete user',
  enter_signature_data_for_petition: 'enter signature data for petition',
  generate_blank_petition: 'generate blank petition',
  generate_downloaded_petition: 'generate downloaded petition',
  generate_emailed_petition: 'generate emailed petition',
  generate_csv_for_printing: 'generate csv for printing',
  'generate_in-person_request_petition': 'generate in-person request petition',
  generate_mail_request_petition: 'generate mail request petition',
  generate_signature_rejected_petition: 'generate signature rejected petition',
  invite_user_to_initiative: 'invite user to initiative',
  can_invite_outside_team: 'can invite outside team',
  make_user_super_admin: 'make user super admin',
  read_donations: 'read donations',
  read_initiative: 'read initiative',
  read_jurisdiction: 'read jurisdiction',
  read_landing_page: 'read landing page',
  read_landing_page_submission: 'read landing page submission',
  read_organization: 'read organization',
  read_petition: 'read petition',
  read_push: 'read push',
  read_setting: 'read setting',
  read_shared_page: 'read shared page',
  read_signed_petitions: 'read signed petitions',
  read_signer_actions: 'read signer actions',
  read_team: 'read team',
  read_user: 'read user',
  read_registration_form: 'read registration form',
  review_petition: 'review petition',
  scan_petition: 'scan petition',
  scan_qr_code: 'scan qr code',
  select_admin_mode: 'select admin mode',
  update_initiative: 'update initiative',
  update_jurisdiction: 'update jurisdiction',
  update_landing_page: 'update landing page',
  update_organization: 'update organization',
  update_petition: 'update petition',
  view_petition_field_status: 'view petition field status',
  update_push: 'update push',
  update_setting: 'update setting',
  update_signed_petition: 'update signed petition',
  update_team: 'update team',
  update_user: 'update user',
  updated_at: 'updated_at',
  view_assign_petitions: 'view assign petitions',
  view_dashboard: 'view dashboard',
  view_donations: 'view donations',
  view_enter_signature_data: 'view enter signature data',
  view_generate_petitions: 'view generate petitions',
  view_initiatives: 'view initiatives',
  view_jurisdictions: 'view jurisdictions',
  view_global_settings: 'view global settings',
  view_landing_pages: 'view landing pages',
  view_organizations: 'view organizations',
  view_pushes: 'view pushes',
  view_review_petitions: 'view review petitions',
  view_settings: 'view settings',
  view_users: 'view users',
  view_users_initiative_role: 'can watch users initiative role',
  view_users_teams: 'view users teams',
  view_user_field_features: 'view user field features',
  create_donate_form: 'create donate form',
  read_donate_form: 'read donate form',
  update_donate_form: 'update donate form',
  delete_donate_form: 'delete donate form',
  read_label: 'read label',
  create_label: 'create label',
  update_label: 'update label',
  delete_label: 'delete label',
  create_category: 'create category',
  read_category: 'read category',
  update_category: 'update category',
  delete_category: 'delete_category',
  view_manual_in_admin_dropdown: 'view_manual_in_admin_dropdown',
  view_manual_in_sidebar: 'view_manual_in_sidebar',
  view_petition_images: 'view petition images',
  read_uploaded_files: 'read upload files',

  // Audits
  create_audit: 'create audit',
  bulk_create_audit: 'bulk create audit',
  update_audit: 'update audit',
  read_audit: 'read audit',
  review_audit: 'review audit',
  assign_audit: 'assign audit',
  self_assign_audit: 'self assign audit',
  delete_audit: 'delete audit',

  view_reports: 'view reports',
  can_forcibly_change_signature_status: 'can forcibly change signature status',
  self_assign_petition_from_assignable_petitions: 'self assign petition from assignable petitions',
  view_field_reports: 'view field reports',
  create_field_report: 'create field report',
  update_field_report: 'update field report',

  // SMS Campaigns
  create_sms_campaigns: 'create sms campaigns',
  read_sms_campaigns: 'read sms campaigns',
  update_sms_campaigns: 'update sms campaigns',
  delete_sms_campaigns: 'delete sms campaigns',

  // SMS Messages
  read_sms_messages: 'read sms messages',
  send_sms_messages: 'send sms messages',

  // Prospects
  read_prospect: 'read prospect',

  // Custom Methods
  read_custom_method: 'read custom method',

  // Duplicate Scan Detection
  pin_petition_as_canonical_scan_lock: 'pin petition as canonical scan lock',
  flag_petition_as_duplicate_scan: 'flag petition as duplicate scan',
};
